import Vue from "vue";
import { Component } from "vue-property-decorator";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DsnManuelleDto } from "../../../dto/GenApi.iNotPaie.Dto/DsnManuelleDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { DsnNatureDeclaration } from "../../../dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration";

@Component({
	components: {
		Loader: require("./../../../shared/components/Loader/Loader.vue.html")
	}
})
export default class ModalEditionDsnComponent extends Vue {
	public isLoading = 0;
	public dsn: DsnManuelleDto = { idDsnMetadata: 0, File: "" };
    public contenuDsn?: string = "";
    public dsnNature?: DsnNatureDeclaration = undefined;

    public Init(idDsnMetadata: number, integreOeth: boolean, nature: DsnNatureDeclaration): void {
        this.isLoading++;
        this.dsnNature = nature;
        ServicesFactoryInstance.DsnService.getDsnDto(idDsnMetadata, integreOeth, data => {
    		this.dsn = data;
    		this.contenuDsn = this.dsn.File;
    		this.isLoading--;
    	}, () => this.isLoading--);
	}

	public envoyer(): void {
   	if (this.dsnValide()) {
    		// Faire dépôt
    		this.faireDepotManuel();
    	}
	}

	public faireDepotManuel(): void {
    	this.isLoading++;
    	ServicesFactoryInstance.DsnService.envoyerDepotManuel(this.dsn, () => {
    		this.isLoading--;
    		this.contenuDsn = "";
    		$("#modalEditionDsnComponent").modal("hide");
            this.$emit("Fermeture", this.dsnNature);
    	}, () => this.isLoading--);
	}

	public dsnValide(): boolean {
    	const rubriqueNombreLigne = "S90.G00.90.001";

    	// Contrôle validite fichier DSN
    	if (this.dsn == undefined || this.contenuDsn == undefined || this.contenuDsn == "") {
    		NotificationServiceInstance.SendFailed("Le fichier dsn est incorrect");

    		return false;
    	}

    	// Contrôle rubrique S90.G00.90.001 présente
    	if (this.contenuDsn.toUpperCase().indexOf(rubriqueNombreLigne) >= 0) {
    		// Contrôle si la rubrique apparaît plusieurs fois
    		if ((this.contenuDsn.toUpperCase().match(/S90.G00.90.001/g) || []).length > 1) {
    			NotificationServiceInstance.SendFailed("La rubrique S90.G00.90.001 apparaît plusieurs fois");

    			return false;
    		} else {
    			// Contrôle nombre de ligne
    			const listeRubriques = this.contenuDsn.split("\n");
    			let file = "";
    			const nombreDeLigne = listeRubriques.length;
    			for (let i = 0; i < listeRubriques.length; i++) {
    				if (listeRubriques[i].toUpperCase().indexOf(rubriqueNombreLigne) >= 0) {
    					listeRubriques[i] = `${rubriqueNombreLigne},'${nombreDeLigne}'`;
    				}

    				file += listeRubriques[i] + "\n";
    			}

    			this.dsn.File = file;
    		}
    	} else {
    		NotificationServiceInstance.SendFailed("Rubrique S90.G00.90.001 manquante");

    		return false;
    	}

    	return true;
	}

	public annuler(): void {
    	this.contenuDsn = "";
    	$("#modalEditionDsnComponent").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/modalEditionDsn/modalEditionDsn.ts